<template>
  <div class="selector-body">
    <div class="columns is-variable is-3">
      <div class="column is-3">
        <div class="repair-section">
          <div class="section-title mb-2">Repair Section</div>
          <div class="is-4 mb-2">Quick select zones of impact</div>
          <div class="repair-area-toggles">
            <div v-for="area in defaultAreas"
              :key="area"
              class="repair-area-toggle mb-3">
              <button
                :class="['button', 'is-fullwidth', 'repair-toggle-btn', {
                  'is-primary': isAreaSelected(area)
                }]"
                @click="toggleRepairArea(area)">
                <span>{{ area }} {{ !area.toUpperCase().startsWith('TRIM') ? 'Section' : '' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-5">
        <div class="diagram-section">
          <div class="is-flex is-align-items-center diagram-container">
            <div class="section-title mb-2"
              style="flex: 1; text-align: center;">Butterfly</div>
            <div class="ml-auto is-flex">
              <!-- <button class="button is-danger is-inverted mr-2"
                @click="selectNone">
                <i class="mdi mdi-checkbox-blank-outline" /> Select None
              </button> -->
              <!-- <button class="button is-primary is-inverted"
                @click="selectAll">
                <i class="mdi mdi-checkbox-intermediate" /> Select All
              </button> -->
            </div>
          </div>
          <div class="vehicle-diagram pt-5">
            <!-- Replace with actual image or SVG as needed -->
            <div class="vehicle-diagram-image">
              <svg version="1.1"
                id="sedan-svg"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 329.8 656.1"
                class="sedan-diagram clickable-svg"
                xml:space="preserve">
                <path id="FrontWindscreen"
                  class="has-tooltip"
                  :class="{ selected: isPartSelected('FrontWindscreen'), hovered: isPartHovered('FrontWindscreen') }"
                  data-tippy-content="Front Windscreen"
                  @click="selectPartBySection('FrontWindscreen')"
                  @mouseenter="onPathMouseEnter('FrontWindscreen')"
                  @mouseleave="onPathMouseLeave"
                  d="M164.3,185.4c52.8,1,78.6,10.6,90.7,18l9.6-49.7c0,0-13.7-25.1-100.5-26.7c-86.8,2.3-98.8,26.1-98.8,26.1l9.5,50.1C86.3,196.2,111.4,186.8,164.3,185.4z" />
                <path id="Turret"
                  class="has-tooltip"
                  :class="{ selected: isPartSelected('Turret'), hovered: isPartHovered('Turret') }"
                  data-tippy-content="Turret"
                  @click="selectPartBySection('Turret')"
                  @mouseenter="onPathMouseEnter('Turret')"
                  @mouseleave="onPathMouseLeave"
                  d="M254.1,208.1c-12.4-7.4-38.1-16.6-89.9-17.6c-51.2,1.3-76.4,10.2-88.4,17.2c2.8,23,23.8,199.2,11.6,282.4c13.4,5,38.7,11.6,78.8,12.3c40.2-1,65.4-7.9,78.7-12.9C231.6,403.6,250.3,244.9,254.1,208.1z" />
                <path id="RightCantRail"
                  class="has-tooltip"
                  data-tippy-content="Right Cant Rail"
                  :class="{ selected: isPartSelected('RightCantRail'), hovered: isPartHovered('RightCantRail') }"
                  @click="selectPartBySection('RightCantRail')"
                  @mouseenter="onPathMouseEnter('RightCantRail')"
                  @mouseleave="onPathMouseLeave"
                  d="M249.9,488c-5-35.1-4.9-83.1-3.7-129.3c0.1-2.7,2.1-121.7,22.6-204.5l9.9-7.3c-15.2,47-21.1,206.9-21.3,209.6c-1.2,46.2-0.3,92,4.7,127.1" />
                <path id="LeftCantRail"
                  class="has-tooltip"
                  data-tippy-content="Left Cant Rail"
                  :class="{ selected: isPartSelected('LeftCantRail'), hovered: isPartHovered('LeftCantRail') }"
                  @click="selectPartBySection('LeftCantRail')"
                  @mouseenter="onPathMouseEnter('LeftCantRail')"
                  @mouseleave="onPathMouseLeave"
                  d="M82.7,488.6c4.7-35.2,4.2-83.2,2.6-129.4c-0.2-2.7-3.1-121.6-24.3-204.3l-10-7.2c15.6,46.9,22.8,206.7,23,209.4c1.6,46.2,1,92-3.7,127.1" />
                <path id="LeftFrontDoor"
                  class="has-tooltip"
                  data-tippy-content="Left Front Door"
                  :class="{ selected: isPartSelected('LeftFrontDoor'), hovered: isPartHovered('LeftFrontDoor') }"
                  @click="selectPartBySection('LeftFrontDoor')"
                  @mouseenter="onPathMouseEnter('LeftFrontDoor')"
                  @mouseleave="onPathMouseLeave"
                  d="M0,192c0.4-6.9,3.1-13.5,7.6-18.7c5-5.9,14.8-7.8,21-8.3c-0.5-25.3-1.2-32.6-1.2-32.6l18.7,13.4c0,0,17.4,89.6,18.7,176.1h-1.9L31.6,322l-1.8-102.5c-0.3-13.2-0.5-24.7-0.7-35.3C15.4,190,0,192,0,192z" />
                <path id="RightFrontDoor"
                  class="has-tooltip"
                  data-tippy-content="Right Front Door"
                  :class="{ selected: isPartSelected('RightFrontDoor'), hovered: isPartHovered('RightFrontDoor') }"
                  @click="selectPartBySection('RightFrontDoor')"
                  @mouseenter="onPathMouseEnter('RightFrontDoor')"
                  @mouseleave="onPathMouseLeave"
                  d="M329.8,190.7c-0.5-6.9-3.2-13.5-7.7-18.7c-5.1-5.9-14.9-7.6-21-8.2c0.3-25.3,0.9-32.6,0.9-32.6l-18.6,13.6c0,0-16.7,89.7-17.2,176.2h1.9l31.3-0.1l1-102.5c0.2-13.2,0.3-24.7,0.4-35.3C314.4,188.8,329.8,190.7,329.8,190.7z" />
                <path id="LeftRearDoor"
                  class="has-tooltip"
                  data-tippy-content="Left Rear Door"
                  :class="{ selected: isPartSelected('LeftRearDoor'), hovered: isPartHovered('LeftRearDoor') }"
                  @click="selectPartBySection('LeftRearDoor')"
                  @mouseenter="onPathMouseEnter('LeftRearDoor')"
                  @mouseleave="onPathMouseLeave"
                  d="M64.2,326.6c0,0,2.8,54,2,79.7c0,0.3,0,0.5,0,0.7c-0.3,30.1-3.1,56.5-4.6,75.6l-17.9-6.5c-4.8-22.2-9.1-49.9-10.2-77.3c-0.8-18.4-1.5-44.3-2.3-72.1L64.2,326.6z" />
                <path id="RightRearDoor"
                  class="has-tooltip"
                  data-tippy-content="Right Rear Door"
                  :class="{ selected: isPartSelected('RightRearDoor'), hovered: isPartHovered('RightRearDoor') }"
                  @click="selectPartBySection('RightRearDoor')"
                  @mouseenter="onPathMouseEnter('RightRearDoor')"
                  @mouseleave="onPathMouseLeave"
                  d="M265.6,325.8c0,0-2.4,54.1-1.3,79.7c0,0.3,0,0.5,0,0.7c0.5,30.1,3.6,56.5,5.2,75.6l17.9-6.7c4.6-22.2,8.7-50,9.6-77.4c0.6-18.4,1.2-44.3,1.7-72.1L265.6,325.8z" />
                <path id="FrontBumper"
                  class="has-tooltip"
                  data-tippy-content="Front Bumper"
                  :class="{ selected: isPartSelected('FrontBumper'), hovered: isPartHovered('FrontBumper') }"
                  @click="selectPartBySection('FrontBumper')"
                  @mouseenter="onPathMouseEnter('FrontBumper')"
                  @mouseleave="onPathMouseLeave"
                  d="M236.2,27.2c-4.1-8.8-7.2-15.1-8.7-17.2c-6.4-9-61.4-10-61.4-10h-0.3c0,0-55,1-61.4,10c-1.5,2.1-4.8,8.6-8.9,17.8C132.2,23.7,179.8,19.8,236.2,27.2z" />
                <path id="RightFrontLamps"
                  class="has-tooltip"
                  data-tippy-content="Right Front Lamps"
                  :class="{ selected: isPartSelected('RightFrontLamps'), hovered: isPartHovered('RightFrontLamps') }"
                  @click="selectPartBySection('RightFrontLamps')"
                  @mouseenter="onPathMouseEnter('RightFrontLamps')"
                  @mouseleave="onPathMouseLeave"
                  d="M269.7,32.2c-13.4-15.7-16.1-17.8-38.3-23.6c4.4,7.2,6.6,12.1,10,19.2C252.4,28.8,260.6,30.6,269.7,32.2z" />
                <path id="LeftFrontLamps"
                  class="has-tooltip"
                  data-tippy-content="Left Front Lamps"
                  :class="{ selected: isPartSelected('LeftFrontLamps'), hovered: isPartHovered('LeftFrontLamps') }"
                  @click="selectPartBySection('LeftFrontLamps')"
                  @mouseenter="onPathMouseEnter('LeftFrontLamps')"
                  @mouseleave="onPathMouseLeave"
                  d="M60.1,32.2C73.5,16.5,76.2,14.4,98.4,8.6c-4.4,7.2-6.6,12.1-10,19.2C77.4,28.8,69.2,30.6,60.1,32.2z" />
                <path id="RightFrontGuard"
                  class="has-tooltip"
                  data-tippy-content="Right Front Guard"
                  :class="{ selected: isPartSelected('RightFrontGuard'), hovered: isPartHovered('RightFrontGuard') }"
                  @click="selectPartBySection('RightFrontGuard')"
                  @mouseenter="onPathMouseEnter('RightFrontGuard')"
                  @mouseleave="onPathMouseLeave"
                  d="M288.8,71.2c-1.9-6.2-4.7-12.8-8.4-19.4c-2.8-5.2-6-10.1-9.7-14.6l-0.1-0.1c-9.5-2.1-19.2-3.6-28.9-4.5c8.8,17.2,19.1,43.1,27.2,67c5,13.5,9.6,26.9,13,38.8l17.1-11.6C299,126.8,298.5,99.2,288.8,71.2z" />
                <path id="LeftFrontGuard"
                  class="has-tooltip"
                  data-tippy-content="Left Front Guard"
                  :class="{ selected: isPartSelected('LeftFrontGuard'), hovered: isPartHovered('LeftFrontGuard') }"
                  @click="selectPartBySection('LeftFrontGuard')"
                  @mouseenter="onPathMouseEnter('LeftFrontGuard')"
                  @mouseleave="onPathMouseLeave"
                  d="M41,71.2c1.9-6.2,4.7-12.8,8.4-19.4c2.8-5.2,6-10.1,9.7-14.6l0.1-0.1c9.5-2.1,19.2-3.6,28.9-4.5c-8.8,17.2-19.1,43.1-27.2,67c-5,13.5-9.6,26.9-13,38.8l-17.1-11.6C30.8,126.8,31.3,99.2,41,71.2z" />
                <path id="Bonnet"
                  class="has-tooltip"
                  :class="{ selected: isPartSelected('Bonnet'), hovered: isPartHovered('Bonnet') }"
                  data-tippy-content="Bonnet"
                  @click="selectPartBySection('Bonnet')"
                  @mouseenter="onPathMouseEnter('Bonnet')"
                  @mouseleave="onPathMouseLeave"
                  d="M267.8,146.2l7.7-5.3C272,116,248.6,60,235.1,31.5C178.7,24.3,131,28,94.4,32.1C80.8,61,57.5,117,54.2,141.5l7.5,5.2c2.1-2.8,20.1-22.6,103.2-24.2C245,123.9,264.6,142.4,267.8,146.2z" />
                <path id="LeftQuarterPanel"
                  class="has-tooltip"
                  :class="{ selected: isPartSelected('LeftQuarterPanel'), hovered: isPartHovered('LeftQuarterPanel') }"
                  data-tippy-content="Left Quarter Panel"
                  @click="selectPartBySection('LeftQuarterPanel')"
                  @mouseenter="onPathMouseEnter('LeftQuarterPanel')"
                  @mouseleave="onPathMouseLeave"
                  d="M43.2,481.2l18.4,6.3c0,0-3.5,34.1,11.8,132c0,0-12.9-6-17.2-12.3C56,607.3,32.4,531.3,43.2,481.2z" />
                <path id="RightQuarterPanel"
                  class="has-tooltip"
                  :class="{ selected: isPartSelected('RightQuarterPanel'), hovered: isPartHovered('RightQuarterPanel') }"
                  data-tippy-content="Right Quarter Panel"
                  @click="selectPartBySection('RightQuarterPanel')"
                  @mouseenter="onPathMouseEnter('RightQuarterPanel')"
                  @mouseleave="onPathMouseLeave"
                  d="M286.6,481.2l-18.4,6.3c0,0,3.5,34.1-11.8,132c0,0,12.9-6,17.2-12.3C273.8,607.3,297.4,531.3,286.6,481.2z" />
                <path id="RearBumper"
                  class="has-tooltip"
                  :class="{ selected: isPartSelected('RearBumper'), hovered: isPartHovered('RearBumper') }"
                  data-tippy-content="Rear Bumper"
                  @click="selectPartBySection('RearBumper')"
                  @mouseenter="onPathMouseEnter('RearBumper')"
                  @mouseleave="onPathMouseLeave"
                  d="M165.2,632.8c-43.2,0.3-72.3-3.2-88.2-5.8c1.4,7.5,3.4,15.3,5.8,19.4c0,0,39.7,10.1,81.9,9.7h0.3c42.2,0.4,81.8-9.7,81.8-9.7c2.5-4.2,4.4-12.3,5.9-20C236.8,629.1,207.9,632.8,165.2,632.8z" />
                <path id="RearWindscreen"
                  class="has-tooltip"
                  :class="{ selected: isPartSelected('RearWindscreen'), hovered: isPartHovered('RearWindscreen') }"
                  data-tippy-content="Rear Windscreen"
                  @click="selectPartBySection('RearWindscreen')"
                  @mouseenter="onPathMouseEnter('RearWindscreen')"
                  @mouseleave="onPathMouseLeave"
                  d="M164.5,552.2c-44.3,0.5-91.7-12.9-91.7-12.9c-5.8-12.6-3.4-51-3.4-51s30.9,18.2,95.3,17.7c64.4,0.5,95.3-17.7,95.3-17.7s3.4,38.4-2.5,51c0,0-48.3,13.4-92.6,12.9" />
                <path id="Bootlid"
                  class="has-tooltip"
                  :class="{ selected: isPartSelected('Bootlid'), hovered: isPartHovered('Bootlid') }"
                  data-tippy-content="Bootlid"
                  @click="selectPartBySection('Bootlid')"
                  @mouseenter="onPathMouseEnter('Bootlid')"
                  @mouseleave="onPathMouseLeave"
                  d="M164.9,556.3h-0.3c-40.8,0.4-84-10.5-93.1-12.9c0.6,10.4,3.3,55.1,7.7,77.6c9.3,2.1,37.6,7.3,86.2,7c48.2,0,76.4-5.4,85.9-7.6c4.1-21.9,6.4-64.7,7-76.7C247.7,546.4,204.8,556.8,164.9,556.3z" />
                <path id="RightRearLamps"
                  class="has-tooltip"
                  :class="{ selected: isPartSelected('RightRearLamps'), hovered: isPartHovered('RightRearLamps') }"
                  data-tippy-content="Right Rear Lamps"
                  @click="selectPartBySection('RightRearLamps')"
                  @mouseenter="onPathMouseEnter('RightRearLamps')"
                  @mouseleave="onPathMouseLeave"
                  d="M257.1,625.8c-1.4,7.6-3.3,15.5-5.7,20.1c3.6-1.6,10.7-5,13.4-7.7c3.6-3.8,8.3-23,8.3-23S267,620.2,257.1,625.8z" />
                <path id="LeftRearLamps"
                  class="has-tooltip"
                  :class="{ selected: isPartSelected('LeftRearLamps'), hovered: isPartHovered('LeftRearLamps') }"
                  data-tippy-content="Left Rear Lamps"
                  @click="selectPartBySection('LeftRearLamps')"
                  @mouseenter="onPathMouseEnter('LeftRearLamps')"
                  @mouseleave="onPathMouseLeave"
                  d="M72.7,625.8c1.4,7.6,3.3,15.5,5.7,20.1c-3.6-1.6-10.7-5-13.4-7.7c-3.6-3.8-8.3-23-8.3-23S62.8,620.2,72.7,625.8z" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="groups-section">
          <div class="section-title is-6 mb-2 is-flex is-justify-content-space-between">
            <span>Selected Areas</span>
            <span v-if="selectedItems.length > 0"
              class="tag is-primary is-size-6 is-rounded has-text-white">
              {{ selectedItemsSelectedCount }} / {{ selectedItemsCount }}
            </span>
          </div>
          <div class="groups-selection">
            <div v-if="selectedAreasParts.length > 0"
              class="selected-groups">
              <div v-for="(group, gIdx) in selectedAreasParts"
                :key="gIdx"
                :ref="`group-${group.name}`"
                class="group-block">
                <div class="group-title">
                  <span class="group-name">{{ group.name }}</span>
                  <div class="group-actions ml-auto">
                    <button
                      class="button is-small is-text"
                      @click="selectAllInGroup(group)"
                      :disabled="areAllPartsSelectedInGroup(group)"
                      title="Select All">
                      <span class="icon has-text-success">
                        <i class="mdi mdi-select-all mdi-24px" />
                      </span>
                    </button>
                    <button
                      class="button is-small is-text"
                      @click="selectNoneInGroup(group)"
                      :disabled="areNoPartsSelectedInGroup(group)"
                      title="Select None">
                      <span class="icon has-text-grey">
                        <i class="mdi mdi-select-off mdi-24px" />
                      </span>
                    </button>
                  </div>
                </div>
                <draggable v-model="group.items"
                  class="draggable-parts"
                  :options="{
                    animation: 150,
                    ghostClass: 'ghost-part',
                    chosenClass: 'chosen-part',
                    handle: '.part-handle',
                    containment: 'parent',
                    preventOnFilter: false,
                    forceFallback: true,
                    fallbackClass: 'fallback-part'
                  }"
                  @start="onPartDragStart"
                  @move="onPartDragMove"
                  @end="onPartDragEnd(group, gIdx)">
                  <div v-for="(item) in group.items"
                    :key="item.partid"
                    class="group-item is-flex is-justify-content-space-between">
                    <!-- <label class="checkbox">
                      <input type="checkbox"
                        v-model="item.checked"
                        class="mr-2"
                        @change="updateSelectedItems">
                      {{ item.partname }}
                    </label> -->
                    <div class="is-flex is-align-items-center"
                      style="width: 100%;">
                      <div class="pretty p-icon p-curve p-smooth m-0 p-bigger">
                        <input type="checkbox"
                          v-model="item.checked"
                          @change="updateSelectedItems">
                        <div class="state">
                          <i class="icon mdi mdi-check" />
                          <label />
                        </div>
                      </div>
                      <span class="ml-2">{{ item.partname }}</span>
                    </div>
                    <span class="mso mso-16px part-handle is-flex is-align-items-flex-end">swap_vert</span>
                  </div>
                </draggable>
              </div>
            </div>
            <section v-else
              class="section">
              <div class="content has-text-grey has-text-centered">
                <span icon="icon is-large">
                  <i class="mdi mdi-48px mdi-car-off" />
                </span>
                <p>There are no items in your list.</p>
                <p>Start by selecting zones of impacts or areas from the vehicle butterfly.</p>
              </div>
            </section>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import QuoteService from '@/views/quote/QuoteService'
import {
  repairAreaGroupingData,
  repairAreas,
  sectionToAreaMapping,
  getAllRepairAreas
} from '@/views/quote/components/repairAreaGroupingData.js'
import tippy from 'tippy.js'

export default {
  name: 'VehicleButterflySelectorV2',
  components: {
    draggable
  },
  props: {
    // active: { type: Boolean, default: false },
    value: { type: Array, default: () => [] },
    entity: { type: Object, default: () => {} }
  },
  data() {
    return {
      // isActive: this.active,
      baseAreasParts: [],
      defaultAreas: Object.values(repairAreas),
      selectedItems: [],
      selectedAreas: [],
      selectedSections: [],
      hoveredArea: null,
      hoveredSection: null,
      selectedAreasParts: [],
      tooltipInstances: null
    }
  },
  computed: {
    selectedItemsCount() {
      return this.selectedAreas.reduce((total, area) => {
        const areaParts = this.baseAreasParts.find(ap => ap.area === area)?.parts || []
        return total + areaParts.length
      }, 0)
    },
    selectedItemsSelectedCount() {
      return this.selectedItems.filter(item => item.selected).length
    }
  },
  watch: {
    // value: {
    //   handler(val) {
    //     if (JSON.stringify(val) !== JSON.stringify(this.selectedItems)) {
    //       this.selectedItems = [...val]
    //     }
    //   },
    //   deep: true
    // }
  },
  async created() {
    this.constructAreaParts()
    await this.getQuoteAreaParts()
  },
  mounted() {
    this.initTippy()
  },
  beforeDestroy() {
    if (this.tooltipInstances) {
      this.tooltipInstances.forEach(instance => instance.destroy())
      this.tooltipInstances = null
    }
  },
  methods: {
    initTippy() {
      this.tooltipInstances = tippy('.has-tooltip')
    },
    constructAreaParts() {
      const allAreas = getAllRepairAreas()
      this.baseAreasParts = allAreas.map((areaData) => {
        const parts = areaData.items
          .map((item) => ({
            partid: item.partId,
            partname: item.partName,
            sortOrder: item.sortOrder
          }))
          .sort((a, b) => (a.sortOrder || 999) - (b.sortOrder || 999))
        return {
          area: areaData.title,
          parts
        }
      })
    },
    async getQuoteAreaParts() {
      const dbParts = await QuoteService.getQuoteButterfly(this.entity.quoteId)

      if (dbParts.length) {
        this.selectedItems = dbParts.map((dbPart) => {
          const area = dbPart.area
          const allSections = this.findAllSectionsForPart(dbPart.butterflyCode, area)
          return {
            partId: dbPart.butterflyCode,
            partName: dbPart.butterflyDesc,
            area: area, //this.determinePartArea(dbPart.butterflyCode),
            sections: allSections, // Store all sections
            selected: dbPart.isSelected,
            areaSortNo: this.getFixedAreaSortOrder(this.determinePartArea(dbPart.butterflyCode)),
            sortOrder: dbPart.sortOrder
          }
        })

        const selectedAreaNames = [...new Set(this.selectedItems.map((s) => s.area))]

        this.selectedAreas = selectedAreaNames

        // Initialize selected sections based on selected areas
        this.selectedSections = []
        // Find distinct sections from selectedItems and assign to selectedSections, matching by partId and area
        // Use a Set to collect all unique sections
        const sectionsSet = new Set()
        this.selectedItems
          .filter(item => item.selected)
          .forEach((item) => {
            // Find all sections where both partId and area match
            const allSections = this.findAllSectionsForPart(item.partId, item.area)
            allSections.forEach(section => {
              if (section) {
                sectionsSet.add(section)
              }
            })
          })
        this.selectedSections = Array.from(sectionsSet)

        this.selectedAreasParts = selectedAreaNames
          .map((areaName) => {
            const found = this.baseAreasParts.find((a) => a.area === areaName)
            if (found && found.parts.length > 0) {
              const dbButterflyCodes = this.selectedItems.filter((s) => s.area === areaName).map((s) => s.partId)

              // const areaSortNo = this.getFixedAreaSortOrder(areaName)

              const partsWithCheckedStatus = found.parts
                .map((part) => {
                  const matchedItem = this.selectedItems.find((s) => s.area === areaName && s.partId === part.partid)
                  return {
                    ...part,
                    checked: matchedItem ? matchedItem.selected : dbButterflyCodes.includes(part.partid),
                    selected: matchedItem ? matchedItem.selected : dbButterflyCodes.includes(part.partid),
                    sortOrder: matchedItem ? matchedItem.sortOrder : part.sortOrder
                  }
                })
                .sort((a, b) => (a.sortOrder || 999) - (b.sortOrder || 999))

              return {
                name: areaName,
                items: partsWithCheckedStatus
              }
            }
            return null
          })
          .filter(Boolean)
          .sort((a, b) => {
            const aOrder = this.getFixedAreaSortOrder(a.name)
            const bOrder = this.getFixedAreaSortOrder(b.name)
            return aOrder - bOrder
          })

        this.sortCheckedPartsToTop()

        this.$emit('input', this.selectedItems)
      }
    },
    determinePartArea(partId) {
      for (const areaData of Object.values(repairAreaGroupingData)) {
        if (areaData.partIds.includes(partId)) {
          return areaData.title
        }
      }
      return 'Other'
    },
    getFixedAreaSortOrder(areaName) {
      // Use the sortOrder from repairAreaGroupingData
      const allAreas = getAllRepairAreas()
      const areaData = allAreas.find((area) => area.title === areaName)
      return areaData ? areaData.sortOrder : 999
    },
    getSectionsByArea(areaName) {
      // Get all sections for a specific area with their data
      return Object.keys(sectionToAreaMapping)
        .filter((sectionName) => sectionToAreaMapping[sectionName].area === areaName)
        .map((sectionName) => ({
          name: sectionName,
          data: sectionToAreaMapping[sectionName]
        }))
    },
    getPartsForSection(sectionName) {
      // Get parts specific to a section
      const sectionData = sectionToAreaMapping[sectionName]
      return sectionData ? sectionData.items : []
    },
    findSectionForPart(partId, areaName) {
      // Find which section a part belongs to within a specific area
      return Object.keys(sectionToAreaMapping).find((sectionName) => {
        const sectionData = sectionToAreaMapping[sectionName]
        return sectionData && sectionData.area === areaName && sectionData.items && sectionData.items.some((sectionPart) => sectionPart.partId === partId)
      })
    },
    findAllSectionsForPart(partId, areaName) {
      // Find all sections that a part belongs to within a specific area
      return Object.keys(sectionToAreaMapping).filter((sectionName) => {
        const sectionData = sectionToAreaMapping[sectionName]
        return sectionData && sectionData.area === areaName && sectionData.items && sectionData.items.some((sectionPart) => sectionPart.partId === partId)
      })
    },
    findAllSectionsByPartId(partId) {
      // Find all sections that contain this partId across all areas
      return Object.keys(sectionToAreaMapping).filter((sectionName) => {
        const sectionData = sectionToAreaMapping[sectionName]
        return sectionData && sectionData.items && sectionData.items.some((sectionPart) => sectionPart.partId === partId)
      })
    },
    isPartInAnySelectedSection(partId, areaName) {
      // Check if a part belongs to any selected section in the given area
      const selectedSectionsForArea = this.selectedSections.filter((section) => this.mapCellToArea(section) === areaName)
      const partSections = this.findAllSectionsForPart(partId, areaName)
      return partSections.some((section) => selectedSectionsForArea.includes(section))
    },
    mapCellToArea(cellName) {
      if (this.defaultAreas.includes(cellName)) {
        return cellName
      }

      // Use the imported sectionToAreaMapping from repairAreaGroupingData
      const sectionData = sectionToAreaMapping[cellName]
      return sectionData ? sectionData.area : 'Other'
    },

    isSelected(cell) {
      return cell && this.selectedAreas.includes(this.mapCellToArea(cell.name))
    },
    getAllSectionsForArea(areaName) {
      // Use the imported sectionToAreaMapping from repairAreaGroupingData
      return Object.keys(sectionToAreaMapping).filter((section) => sectionToAreaMapping[section].area === areaName)
    },
    areAllSectionsSelectedForArea(areaName) {
      const sectionsForArea = this.getAllSectionsForArea(areaName)
      return sectionsForArea.length > 0 && sectionsForArea.every((section) => this.selectedSections.includes(section))
    },
    toggleSection(sectionName) {
      const areaName = this.mapCellToArea(sectionName)
      const sectionIndex = this.selectedSections.indexOf(sectionName)

      if (sectionIndex === -1) {
        // Select the section and its specific parts
        this.selectedSections.push(sectionName)
        this.addSectionParts(sectionName, areaName)
        // Ensure the area is shown in selectedAreasParts even if not all sections are selected
        this.ensureAreaIsDisplayed(areaName)
      } else {
        // Deselect the section and its specific parts
        this.selectedSections.splice(sectionIndex, 1)
        this.removeSectionParts(sectionName, areaName)
      }

      const areaIndex = this.selectedAreas.indexOf(areaName)
      const isNewArea = areaIndex === -1

      if (isNewArea) {
        this.selectedAreas.push(areaName)
      }

      this.updateSelectedPartsDisplay()

      // Scroll to the newly added area after DOM update
      if (isNewArea && sectionIndex === -1) {
        this.$nextTick(() => {
          this.scrollToArea(areaName)
        })
      }

      this.$emit('input', this.selectedItems)
    },
    ensureAreaIsDisplayed(areaName) {
      // Ensure the area is in selectedAreas for display purposes
      if (!this.selectedAreas.includes(areaName)) {
        this.selectedAreas.push(areaName)
      }
    },
    addSectionParts(sectionName, areaName) {
      // Add parts specific to this section
      const sectionData = sectionToAreaMapping[sectionName]
      if (sectionData && sectionData.items) {
        const areaSortNo = this.getFixedAreaSortOrder(areaName)
        sectionData.items.forEach((part) => {
          const existingIndex = this.selectedItems.findIndex((item) => item.area === areaName && item.partId === part.partId)

          if (existingIndex === -1) {
            // Find all sections this part belongs to
            const allSections = this.findAllSectionsForPart(part.partId, areaName)
            // Add new part
            this.selectedItems.push({
              partId: part.partId,
              partName: part.partName,
              area: areaName,
              sections: allSections, // Store all sections
              areaSortNo: areaSortNo,
              selected: true,
              sortOrder: part.sortOrder || 999
            })
          } else {
            // Update existing part to ensure it's selected
            this.selectedItems[existingIndex].selected = true
            // Update sections array
            const allSections = this.findAllSectionsForPart(part.partId, areaName)
            this.selectedItems[existingIndex].sections = allSections
          }
        })
      }
    },
    removeSectionParts(sectionName, areaName) {
      // Remove parts specific to this section, but only if they don't belong to other selected sections
      const sectionData = sectionToAreaMapping[sectionName]
      if (sectionData && sectionData.items) {
        const partIds = sectionData.items.map((part) => part.partId)

        partIds.forEach((partId) => {
          // Check if this part belongs to any other selected section in the same area
          const otherSelectedSections = this.selectedSections.filter((section) => section !== sectionName && this.mapCellToArea(section) === areaName)

          const belongsToOtherSection = otherSelectedSections.some((otherSection) => {
            const otherSectionData = sectionToAreaMapping[otherSection]
            return otherSectionData && otherSectionData.items && otherSectionData.items.some((item) => item.partId === partId)
          })

          if (!belongsToOtherSection) {
            // Remove the part completely if it doesn't belong to any other selected section
            this.selectedItems = this.selectedItems.filter((item) => item.area !== areaName || item.partId !== partId)
          } else {
            // Update the sections array to reflect remaining selected sections
            const itemIndex = this.selectedItems.findIndex((item) => item.area === areaName && item.partId === partId)
            if (itemIndex !== -1) {
              const allSections = this.findAllSectionsForPart(partId, areaName)
              this.selectedItems[itemIndex].sections = allSections
            }
          }
        })
      }
    },
    addAreaParts(areaName) {
      const found = this.baseAreasParts.find((a) => a.area === areaName)
      if (found && found.parts.length > 0) {
        const areaSortNo = this.getFixedAreaSortOrder(areaName)
        found.parts.forEach((part) => {
          const existingIndex = this.selectedItems.findIndex((item) => item.area === areaName && item.partId === part.partid)

          if (existingIndex === -1) {
            const selectedGroup = this.selectedAreasParts.find((sp) => sp.name === areaName)
            const partInGroup = selectedGroup?.items.find((item) => item.partid === part.partid)
            const isPartChecked = partInGroup ? partInGroup.checked : true

            this.selectedItems.push({
              partId: part.partid,
              partName: part.partname,
              area: areaName,
              areaSortNo: areaSortNo,
              selected: isPartChecked,
              sortOrder: part.sortOrder || 999
            })
          }
        })
      }
    },
    removeAreaParts(areaName) {
      this.selectedItems = this.selectedItems.filter((item) => item.area !== areaName)
    },
    updateSelectedPartsDisplay() {
      console.log('updateSelectedPartsDisplay')
      this.selectedAreasParts = this.selectedAreas
        .map((areaName) => {
          const areaPart = this.baseAreasParts.find((a) => a.area === areaName)
          if (areaPart && areaPart.parts.length > 0) {
            const existingGroup = this.selectedAreasParts.find((sp) => sp.name === areaName)

            const baseAreaParts = this.preserveUserPartOrder(
              areaPart.parts.map((part) => {
                // Check if this part belongs to any selected section in this area
                // const belongsToSelectedSection = this.isPartInAnySelectedSection(part.partid, areaName)

                // Find if this part is in selectedItems
                const selectedItem = this.selectedItems.find((item) => item.area === areaName && item.partId === part.partid)

                return {
                  ...part,
                  // Check the part if it belongs to any selected section OR if it was previously selected
                  // checked: belongsToSelectedSection || !!(selectedItem && selectedItem.selected)
                  checked: !!(selectedItem && selectedItem.selected)
                }
              }),
              existingGroup
            )

            return {
              name: areaName,
              items: baseAreaParts
            }
          }
          return null
        })
        .filter(Boolean)
        .sort((a, b) => {
          const aOrder = this.getFixedAreaSortOrder(a.name)
          const bOrder = this.getFixedAreaSortOrder(b.name)
          return aOrder - bOrder
        })

      this.sortCheckedPartsToTop()
    },
    toggleCell(cell) {
      if (!cell) return
      const areaName = this.mapCellToArea(cell.name)
      const idx = this.selectedAreas.indexOf(areaName)

      if (idx === -1) {
        this.selectedAreas.push(areaName)
        this.addAreaParts(areaName)
        // Scroll to the newly added area after DOM update
        this.$nextTick(() => {
          this.scrollToArea(areaName)
        })
      } else {
        this.selectedAreas.splice(idx, 1)
        this.removeAreaParts(areaName)
      }

      this.updateSelectedPartsDisplay()
      this.updateSelectedSectionsBySelectedItems()

      this.$emit('input', this.selectedItems)
    },
    updateSelectedItems() {
      // this.selectedItems = []
      console.log('updateSelectedItems')
      this.selectedAreasParts.forEach((group) => {
        group.items.forEach((item) => {
          // // Only add items that are checked
          // if (item.checked) {
            // Find all sections this part belongs to within the area
            const belongingSections = this.findAllSectionsForPart(item.partid, group.name)

            // Find if this part already exists in selectedItems
            const existingSelectedItem = this.selectedItems.find(
              (selected) => selected.area === group.name && selected.partId === item.partid
            )

            if (existingSelectedItem) {
              // Update the 'selected' property to match item.checked
              existingSelectedItem.selected = item.checked
              // Store all sections this part belongs to
              existingSelectedItem.sections = belongingSections
            } else {
              this.selectedItems.push({
                partId: item.partid,
                partName: item.partname,
                area: group.name,
                sections: belongingSections, // Store all sections
                selected: item.checked,
                areaSortNo: this.getFixedAreaSortOrder(group.name),
                sortOrder: item.sortOrder || 999
              })
            }
          // }
        })
      })

      // Update selected sections based on checked items
      const newSelectedSections = []
      this.selectedAreasParts.forEach((group) => {
        group.items.forEach((item) => {
          if (item.checked) {
            // Find all sections this checked item belongs to
            let belongingSections = this.findAllSectionsForPart(item.partid, group.name)
            // if (!belongingSections || belongingSections.length === 0) {
            //   console.log('belongingSections is empty, searching across all areas for partId:', item.partid)
            //   belongingSections = this.findAllSectionsByPartId(item.partid)
            // }

            belongingSections.forEach((section) => {
              if (section && !newSelectedSections.includes(section)) {
                newSelectedSections.push(section)
              }
            })
          }
        })
      })

      this.selectedSections = newSelectedSections

      // Update selectedAreas to include areas that have any selected sections
      this.selectedSections.forEach((section) => {
        const area = this.mapCellToArea(section)
        if (area && !this.selectedAreas.includes(area)) {
          this.selectedAreas.push(area)
        }
      })

      this.sortCheckedPartsToTop()

      this.$emit('input', this.selectedItems)
    },
    sortPartsByOrder(parts) {
      return parts.sort((a, b) => (a.sortOrder || 999) - (b.sortOrder || 999))
    },
    preserveUserPartOrder(parts, existingGroup) {
      if (existingGroup && existingGroup.items && existingGroup.items.length > 0) {
        const existingOrder = existingGroup.items.map((item) => item.partid)
        return parts.sort((a, b) => {
          const aIndex = existingOrder.indexOf(a.partid)
          const bIndex = existingOrder.indexOf(b.partid)

          if (aIndex !== -1 && bIndex !== -1) {
            return aIndex - bIndex
          }
          if (aIndex !== -1) return -1
          if (bIndex !== -1) return 1
          return (a.sortOrder || 999) - (b.sortOrder || 999)
        })
      }
      return this.sortPartsByOrder(parts)
    },
    onPartDragEnd(group, groupIndex) {
      console.log(
        `Parts reordered in ${group.name}:`,
        group.items.map((item) => item.partname)
      )

      group.items.forEach((item, index) => {
        item.sortOrder = index + 1

        const selectedItem = this.selectedItems.find((si) => si.partId === item.partid && si.area === group.name)
        if (selectedItem) {
          selectedItem.sortOrder = index + 1
        }
      })

      this.$emit('input', this.selectedItems)
    },
    onPartDragStart(event) {
      event.stopPropagation()
    },
    onPartDragMove(event) {
      event.stopPropagation()
    },
    isPartSelected(sectionName) {
      return this.selectedSections.includes(sectionName)
    },
    isPartHovered(sectionName) {
      return this.hoveredSection === sectionName
    },
    onPathMouseEnter(sectionName) {
      this.hoveredSection = sectionName
      // Also set the hovered area for backward compatibility if needed
      const areaName = this.mapCellToArea(sectionName)
      this.hoveredArea = areaName
    },
    onPathMouseLeave() {
      this.hoveredSection = null
      this.hoveredArea = null
    },
    selectPartBySection(sectionName) {
      this.toggleSection(sectionName)
    },
    isAreaSelected(areaName) {
      return this.selectedAreas.includes(areaName)
    },
    toggleRepairArea(areaName) {
      const cell = { name: areaName }
      this.toggleCell(cell)
    },
    updateSelectedSectionsBySelectedItems() {
      console.log('updateSelectedSectionsBySelectedItems')
      // Update selectedSections based on selectedItems (area + partId)
      const newSelectedSections = []

      this.selectedItems.forEach((selectedItem) => {
        if (selectedItem.selected) {
          // Find all sections this selected item belongs to
          const belongingSections = this.findAllSectionsForPart(selectedItem.partId, selectedItem.area)

          belongingSections.forEach((section) => {
            if (section && !newSelectedSections.includes(section)) {
              newSelectedSections.push(section)
            }
          })
        }
      })

      this.selectedSections = newSelectedSections

      // Update selectedAreas to include areas that have any selected sections
      const newSelectedAreas = []
      this.selectedSections.forEach((section) => {
        const area = this.mapCellToArea(section)
        if (area && !newSelectedAreas.includes(area)) {
          newSelectedAreas.push(area)
        }
      })

      // Merge with existing selectedAreas to preserve areas that might have been added directly
      this.selectedAreas.forEach((area) => {
        if (!newSelectedAreas.includes(area)) {
          newSelectedAreas.push(area)
        }
      })

      this.selectedAreas = newSelectedAreas
    },
    selectAllInGroup(group) {
      // Select all parts in the specific group
      group.items.forEach(item => {
        item.checked = true
      })
      this.updateSelectedItems()
    },
    selectNoneInGroup(group) {
      // Deselect all parts in the specific group
      group.items.forEach(item => {
        item.checked = false
      })
      this.updateSelectedItems()
    },
    areAllPartsSelectedInGroup(group) {
      // Check if all parts in the group are selected
      return group.items.length > 0 && group.items.every(item => item.checked)
    },
    areNoPartsSelectedInGroup(group) {
      // Check if no parts in the group are selected
      return group.items.length === 0 || group.items.every(item => !item.checked)
    },
    reset() {
      // Clear all selections
      this.selectedItems = []
      this.selectedAreas = []
      this.selectedSections = []
      this.selectedAreasParts = []
      this.hoveredArea = null
      this.hoveredSection = null

      // Emit the cleared selection
      this.$emit('input', this.selectedItems)
    },
    scrollToArea(areaName) {
      // Scroll to the specific area group block
      const refName = `group-${areaName}`
      const groupElement = this.$refs[refName]

      if (groupElement && groupElement[0]) {
        groupElement[0].scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    },
    sortCheckedPartsToTop() {
      this.selectedAreasParts.forEach(group => {
        if (group && group.items) {
          group.items.sort((a, b) => {
            if (a.checked === b.checked) {
              if (!a.checked && !b.checked) {
                return (a.sortOrder || 999) - (b.sortOrder || 999)
              }
              return 0
            }

            return a.checked ? -1 : 1
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.selector-body {
  padding: 0 0 0 0;
}
.repair-section {
  border-radius: 8px;
  padding: 1rem;
  height: 60vh;
  overflow-y: auto;
}

.diagram-section {
  border-radius: 8px;
  padding: 1rem;
  height: 60vh;
  overflow-y: auto;
}
.vehicle-diagram .grid {
  gap: 0.5rem;
}
.diagram-cell {
  min-width: 80px;
  min-height: 80px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  padding: 0.5rem;
  text-align: center;
  word-wrap: break-word;
  font-size: clamp(0.1rem, 1vw, 1rem);
}
.diagram-cell.is-selected {
  background: #1976d2;
  color: #fff;
}
.diagram-cell.is-empty {
  opacity: 0;
  cursor: default;
}
.section-title {
  font-weight: 600;
  /* color: #1a5276; */
  color: var(--text-color);
  margin-bottom: 0.5rem;
  font-size: 1.2rem;
}
.groups-section {
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
}
.groups-selection {
  height: 55vh;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}
.group-block {
  margin-bottom: 1.5rem;
  border-radius: 6px;
  padding: 0.5rem;
}
.group-block:hover {
  /* background-color: #fafbfc; */
  background-color: var(--background-hover-color);
}
.group-title {
  font-weight: 600;
  /* color: #1976d2; */
  color: var(--text-color);
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  border-radius: 0;
  /* border-bottom: solid 1px #e7e7e7; */
  border-bottom: solid 1px var(--border-color);
  padding-bottom: 0.25rem;
}

.group-name {
  flex: 1;
}

.group-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.group-actions .button {
  padding: 0.125rem 0.25rem;
  height: auto;
  min-height: 1.5rem;
  border: none;
  background: transparent;
  color: var(--text-color);
}

.group-actions .button:hover:not(:disabled) {
  background-color: var(--background-hover-color);
  /* color: var(--text-color); */
  color: #fff;
}

.group-actions .button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.group-item {
  padding: 0.25rem;
  margin-bottom: 0.25rem;
  border-radius: 4px;
}

.group-item:hover {
  /* background-color: #f8f9fa; */
  background-color: var(--background-hover-color);
}

.group-item .checkbox {
  display: flex;
  align-items: center;
  width: 100%;
}

.part-handle {
  margin-right: 0.5rem;
  /* color: #999; */
  color: var(--text-color);
  cursor: move;
  font-size: 0.9em;
}

.part-handle:hover {
  /* color: #1976d2; */
  color: var(--text-color);
}

.draggable-parts {
  min-height: 20px;
  overflow: hidden;
  position: relative;
  contain: layout style;
}

.ghost-part {
  opacity: 0.5;
  /* background: #f0f8ff; */
  background: var(--background-color);
  /* border: 1px dashed #1976d2; */
  border: 1px dashed var(--border-color);
  border-radius: 4px;
}

.chosen-part {
  background: #e3f2fd;
  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.2);
}

.fallback-part {
  background: #e3f2fd;
  box-shadow: 0 4px 8px rgba(25, 118, 210, 0.3);
  border: 1px solid #1976d2;
  border-radius: 4px;
  z-index: 1000;
  pointer-events: none;
}
.selector-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.vehicle-diagram-image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48vh;
}

.sedan-diagram {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.clickable-svg path:focus {
  outline: none !important;
}

.clickable-svg path {
  fill: #6c757d;
  stroke: #6c757d;
  stroke-width: 2;
  cursor: pointer;
}

.clickable-svg path.hovered {
  fill: #9ec5e9;
  stroke: #9ec5e9;
  stroke-width: 2;
}

.clickable-svg path.selected {
  fill: #3291ef;
  stroke: #3291ef;
  stroke-width: 2;
}

.repair-area-toggles {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.repair-toggle-btn {
  justify-content: flex-start;
  text-align: left;
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
}

.repair-toggle-btn:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.repair-toggle-btn.is-primary {
  background-color: #1976d2;
  border-color: #1976d2;
  color: white;
}

.repair-toggle-btn.is-light {
  background-color: var(--background-color);
  border-color: var(--border-color);
  color: var(--text-color);
  /* background-color: white; */
  /* border-color: #dee2e6; */
  /* color: #495057; */
}

/* .icon.is-filled.has-text-success { background-color: hsl(141, 71%, 48%); }
.icon.is-filled.has-text-grey { background-color: hsl(0, 0%, 71%); } */

</style>